export function insertSpaceEveryNChars(str, n) {
    var result = '';
    for (var i = 0; i < str.length; i++) {
      if (i > 0 && i % n === 0) {
        result += ' ';
      }
      result += str.charAt(i);
    }
    return result;
  }

export const equalsCheck = (a, b) => {  
    return JSON.stringify(a) === JSON.stringify(b);  
}  


export function makeDictFromList(list, key){
  var output = {}
  list.forEach(element => {
    output[element[key]] = element
  });
  return output;
}